import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { Property } from '@propertypal/shared/src/types/property';
import React, { FunctionComponent } from 'react';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import PropertyGrid from '../property/PropertyGrid';
import { Arrow, Container, PopularPropertiesLink, Title } from './PopularPropertiesHome.style';

interface Props {
  title: string;
  properties?: Property[] | null;
  link: string;
  linkText: string;
  maxLength: number;
  imageLocator: string;
  maxColumns?: number;
  photoScroller?: boolean;
  handPicked?: boolean;
  onPropertyClick?: (property: Property) => void;
}

const PopularPropertiesHome: FunctionComponent<Props> = (props) => {
  if (!props.properties) {
    return null;
  }

  return (
    <Container maxLength={props.maxLength}>
      <Title data-testid="popular-properties-title">{props.title}</Title>

      <PopularPropertiesLink href={props.link} data-testid="popular-properties-link">
        {props.linkText}{' '}
        <Arrow>
          <FontAwesomeIcon icon={faAngleRight} style={{ fontSize: 22 }} />
        </Arrow>
      </PopularPropertiesLink>

      {props.properties && (
        <PropertyGrid
          ariaLabel="Recent properties"
          properties={props.properties}
          maxColumns={props.maxColumns || 3}
          imageLocator={props.imageLocator}
          popularProperties
          photoScroller={props.photoScroller}
          handPicked={props.handPicked}
          onPropertyClick={props.onPropertyClick}
        />
      )}
    </Container>
  );
};

export default PopularPropertiesHome;
